import * as serviceContext from "../services/serviceContext";
import { PORT_DEALER } from "../config";

let options = {};
let headers = new Headers();
const token = sessionStorage.getItem("token");

headers.append("Content-Type", "application/json");
headers.append("Authorization", `${token}`);

options.headers = headers;
options.redirect = "follow";

export async function getFeedBackList() {
    try {
        const url = localStorage.getItem('baseUrl');
        const response = await serviceContext.get(`${url}:${PORT_DEALER}dealer/feedback`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function detailOfChat(id) {
    try {
        const url = localStorage.getItem("baseUrl");
        const response = await serviceContext.get(`${url}:${PORT_DEALER}dealer/feedback/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function sendReply(data) {
    try {
        const url = localStorage.getItem("baseUrl");
        const response = await serviceContext.post(`${url}:${PORT_DEALER}dealer/feedback/sendreply`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}